import { render, staticRenderFns } from "./ArticlesEdit.vue?vue&type=template&id=1774fdce&"
import script from "./ArticlesEdit.vue?vue&type=script&lang=js&"
export * from "./ArticlesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports